/**
 * <RouteSeo/> — mounted once inside <BrowserRouter> (App.js).
 *
 * On every pathname change it resolves the route in routes.config.js and
 * writes title / description / canonical / robots / Open Graph / Twitter /
 * JSON-LD into <head>. Unregistered routes resolve to UNMATCHED → noindex,
 * which is what makes the soft-404 shell safe to index-crawl.
 *
 * Tenant subdomains (college portals) are left alone: they are a different
 * site with their own branding and must not carry the main-domain canonicals.
 *
 * Renders nothing.
 */
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveRouteMeta } from './resolveRouteMeta';
import { applyHeadMeta } from './headManager';
import { isMainDomainHost } from './host';

export default function RouteSeo() {
  const { pathname } = useLocation();

  // useLayoutEffect so the head is correct before paint and before any
  // child effect that reads document.title (and before the prerenderer
  // sees data-seo-ready).
  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;
    if (!isMainDomainHost(window.location.hostname)) return;
    applyHeadMeta(resolveRouteMeta(pathname));
  }, [pathname]);

  return null;
}
